import * as React from 'react';
import { MediaQuery } from '@grandvisionhq/common';
import { usePupillaryDistanceAlertLayout } from '../../hooks/use-pupillary-distance-alert-layout.js';
import '@grandvisionhq/configurator';
import '@grandvisionhq/state';
import '../../../../state/actions.js';
import '../../../../state/add-to-cart/selectors.js';
import '../../../../state/bundles/selectors.js';
import '../../../../state/bundles/reducer.js';
import '../../../../state/configurator/selectors.js';
import '../../../../state/configurator/reducer.js';
import '../../../../state/products/selectors.js';
import '../../../../state/products/reducer.js';

const PrescriptionFormLayout = ({ components: { Column , Alert , PupillaryDistanceLink  } ,  })=>{
    const isPhone = MediaQuery.useIsPhone();
    const shouldUseAlertLayout = usePupillaryDistanceAlertLayout();
    if (shouldUseAlertLayout) {
        if (isPhone) {
            return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Column, {
                side: "right",
                parametersType: "nonPupillaryDistance"
            }), /*#__PURE__*/ React.createElement(Alert, null), /*#__PURE__*/ React.createElement(Column, {
                side: "right",
                parametersType: "pupillaryDistance",
                showHeading: false
            }), /*#__PURE__*/ React.createElement(PupillaryDistanceLink, null), /*#__PURE__*/ React.createElement(Column, {
                side: "left",
                parametersType: "nonPupillaryDistance"
            }), /*#__PURE__*/ React.createElement(Alert, null), /*#__PURE__*/ React.createElement(Column, {
                side: "left",
                parametersType: "pupillaryDistance",
                showHeading: false
            }), /*#__PURE__*/ React.createElement(PupillaryDistanceLink, null));
        } else {
            return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Column, {
                side: "right",
                parametersType: "nonPupillaryDistance"
            }), /*#__PURE__*/ React.createElement(Column, {
                side: "left",
                parametersType: "nonPupillaryDistance"
            }), /*#__PURE__*/ React.createElement(Alert, null), /*#__PURE__*/ React.createElement(Column, {
                side: "right",
                parametersType: "pupillaryDistance"
            }), /*#__PURE__*/ React.createElement(Column, {
                side: "left",
                parametersType: "pupillaryDistance"
            }), /*#__PURE__*/ React.createElement(PupillaryDistanceLink, null));
        }
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Column, {
        side: "right",
        parametersType: "all"
    }), isPhone && /*#__PURE__*/ React.createElement(PupillaryDistanceLink, null), /*#__PURE__*/ React.createElement(Column, {
        side: "left",
        parametersType: "all"
    }), /*#__PURE__*/ React.createElement(PupillaryDistanceLink, null));
};

export { PrescriptionFormLayout };
//# sourceMappingURL=PrescriptionFormLayout.js.map
